<template>
    <div class="box">
        <div class="box-head bg-color1 felx-between">
            <div class="box-head-title color1 flex-algin">
                项目分布
            </div>
            <el-select v-model="opt.name" filterable clearable popper-class="fen-sel" class="fen-val" placeholder="选择检索项目"  @change="doFilte">
                <el-option
                v-for="item in projects"
                :key="item.id"
                :label="item.name"
                :value="item.name">
                </el-option>
            </el-select>
        </div>
        <div class="box-table">
            <baidu-map
                :center="center"
                id="xjMap"
                :zoom="zoom"
                @ready="handler"
                style="height:100%;width:100%;"
                @click="getClickInfo"
                :scroll-wheel-zoom="true"
            >
                <bm-marker v-for="item in points" @click="clickHandler(item.id)" :key="item.id" :position="item.position"  :icon="{url: require('../../assets/image/point.png'), size: {width: 50, height: 50}}">
                    <bm-info-window :position="item.position" :title="item.name" :show="curIndex==item.id" @close="infoWindowClose" style="width:300px;border:1px solid #ddd;padding:10px;">
                        <p style="margin:5px 0;">工期：{{item.allDay}}天 &nbsp;&nbsp;&nbsp;&nbsp; 剩余{{item.otherDay}}天({{item.progress}}%)</p>
                        <p style="margin:5px 0;">施工进度：{{item.progress}}%</p>
                        <!-- <p>累计出勤：{{item.ljcq}}</p> -->
                        <button @click="clear(item)" style="background: #3371EC;border: 0;padding: 3px;color: #ffff;border-radius: 3px;">去查看</button>
                    </bm-info-window>
                </bm-marker>
            </baidu-map>
        </div>
    </div>
</template>
<script>
import myHttp from '../../untils/port'
import util from '../../untils/util'
export default {
    data(){
        return{
            center: {
                lng: 117.283334,
                lat: 31.866339
            },
            map: {},
            zoom: 12,
            points:[],
            curIndex:undefined,
            projects:[],
            name:'',
            areaId:'',
            opt:{
                name:'',
                entId:'',
                joinType:'3',
            },
            groupId:'',
        }
    },
    mounted(){
        this.groupId = this.$store.state.groupId
        if ('' == this.groupId || undefined == this.groupId) {
            this.groupId = util.session.get('groupId')
        }
        //this.getData()
        util.session.remove('backPage')
    },
    methods:{
        //监听选择
        doFilte(){
            this.getData()
        },
        //地图展示
        handler({ BMap, map }) {
            this.map = map
            this.getData()
            var cityName = '安徽省';
            map.centerAndZoom(cityName, 11);                     // 初始化地图,设置中心点坐标和地图级别。    map.addControl(new BMap.ScaleControl());                    // 添加比例尺控件
            map.enableScrollWheelZoom();
            var bdary = new BMap.Boundary();
            
            // bdary.get(cityName, function (rs) {       //获取行政区域
            //     //map.clearOverlays();        //清除地图覆盖物
            //     //网上查了下，东西经南北纬的范围
            //     var EN_JW = "180, 90;";         //东北角
            //     var NW_JW = "-180,  90;";       //西北角
            //     var WS_JW = "-180, -90;";       //西南角
            //     var SE_JW = "180, -90;";        //东南角
            //     //4.添加环形遮罩层
            //     var ply1 = new BMap.Polygon(rs.boundaries[0] + SE_JW + SE_JW + WS_JW + NW_JW + EN_JW + SE_JW, {
            //         strokeColor: "none",
            //         fillColor: "#2F3D54",//修改不想显示的地图颜色
            //         fillOpacity: 1,
            //         strokeOpacity: 0.5
            //     }); //建立多边形覆盖物
            
            //     map.addOverlay(ply1);
            //     //5. 给目标行政区划添加边框，其实就是给目标行政区划添加一个没有填充物的遮罩层
            //     var ply = new BMap.Polygon(rs.boundaries[0], {
            //     strokeWeight: 0.0001,
            //     strokeColor: "#00f",
            //     fillColor: "#104da7",//显示的地图区域颜色设置
            //     fillOpacity: 0.0001,
            //     });
            //     map.addOverlay(ply);
            //     //map.setViewport(ply.getPath());    //调整视野
            //     //that.getData()
            // });
        },
        showMarker(list){
            var points = [];
            for (var i = 0; i < list.length; i++) {
                if(list[i].gpsPoint&&''!=list[i].gpsPoint){
                    var obj = list[i]
                    var position = list[i].gpsPoint.split(',')
                    obj.position = {lng: position[0], lat: position[1]}
                    obj.typeName = list[i].projectType=='1'?'房建':'市政'
                    
                    if(list[i].allDay){
                        var readDay = parseInt(list[i].allDay) - parseInt(list[i].otherDay) 
                        obj.progress = ((readDay / list[i].allDay) * 100).toFixed(2)
                    }else{
                        obj.progress = 0
                    }
                    points.push(obj)
                }
            }
            this.center = points.length>0?points[0].position:this.center
            this.points = points
        },
        //地图点击方法
        getClickInfo(e) {

        },
        //点击方法
        clickHandler(e){
            this.curIndex = e
        },
        //关闭
        infoWindowClose(){
            this.curIndex = undefined
        },
        //查看
        clear(row){
            util.session.set('proId', row.id)
            util.session.set('backPage', '1')
            var that = this
            setTimeout(function() {
                that.$router.push({ path: '/entProInfo' })
            }, 0)
        },
        //获取监管端的id
        // getCurArea(){
        //     var that = this
        //     myHttp.getSuperviseById({ id: this.groupId }).then(function(resp) {
        //         if (resp.data.code == '200') {
        //             that.areaId = resp.data.data.supervise.areaId
        //             that.getData()
        //             that.getAllPro()
        //         }
        //     },function() {})
        // },
        //获取数据
        getData(){
            var that = this
            this.opt.entId = this.groupId
            myHttp.getProjectListByEntIdAndJoinType(this.opt).then(function(resp) {
                if (resp.data.code == '200') {
                    var list = resp.data.data.list || []
                    that.projects = list
                    that.showMarker(list)
                }
            })
        },
        //获取所有的项目
        // getAllPro(){
        //     let that = this
        //     myHttp.getAllNameByAreaId({
        //         areaId: this.areaId
        //     }).then(function(resp) {
        //         if (resp.data.code == '200') {
        //             var list = resp.data.data.list
        //             for (var i = 0; i < list.length; i++) {
        //                 list[i].id = i
        //             }
        //             that.projects = list
        //         }
        //         that.projects = list
        //     })
        // },

        baiduMap() {
            var that = this
            this.map = new BMap.Map("xjMap");
            var cityName = '安徽省';
            this.map.centerAndZoom(cityName, 8);                     // 初始化地图,设置中心点坐标和地图级别。    map.addControl(new BMap.ScaleControl());                    // 添加比例尺控件
            this.map.enableScrollWheelZoom();
            var bdary = new BMap.Boundary();
            
            bdary.get(cityName, function (rs) {       //获取行政区域
                //map.clearOverlays();        //清除地图覆盖物
                //网上查了下，东西经南北纬的范围
                var EN_JW = "180, 90;";         //东北角
                var NW_JW = "-180,  90;";       //西北角
                var WS_JW = "-180, -90;";       //西南角
                var SE_JW = "180, -90;";        //东南角
                //4.添加环形遮罩层
                var ply1 = new BMap.Polygon(rs.boundaries[0] + SE_JW + SE_JW + WS_JW + NW_JW + EN_JW + SE_JW, {
                    strokeColor: "none",
                    fillColor: "#2F3D54",//修改不想显示的地图颜色
                    fillOpacity: 1,
                    strokeOpacity: 0.5
                }); //建立多边形覆盖物
            
                that.map.addOverlay(ply1);
                //5. 给目标行政区划添加边框，其实就是给目标行政区划添加一个没有填充物的遮罩层
                var ply = new BMap.Polygon(rs.boundaries[0], {
                strokeWeight: 0.0001,
                strokeColor: "#00f",
                fillColor: "#104da7",//显示的地图区域颜色设置
                fillOpacity: 0.0001,
                });
                that.map.addOverlay(ply);
                //map.setViewport(ply.getPath());    //调整视野
                //that.getData()
            });
            
        },
    }
}
</script>
<style scoped>
    *{
        box-sizing: border-box;
    }
    .box{
        width:100%;
        position: relative;
        height: 100%;
    }
    .map-box{
        width: 100%;
        height: 100%;
        position: relative;
    }
    /* .pro-sel{
        position: absolute;
        top: 0px;
        left: 0px;
        width: 300px;
        height: 50px;
        font-size: 18px;
    } */
    .box-head{
        width: 100%;
        height: 40px;
        position: relative;
        display: flex;
        padding: 0 20px;
        box-sizing: border-box;
        font-size: 16px;
    }
    .box-table{
        width: 100%;
        height: calc( 100% - 40px );
        position: relative;
        /* overflow: auto; */
    }
    .el-table .box-head-title{
        font-size: 16px;
    }


    .flex-algin{
        display: flex;
        align-content: center;
        align-items: center;
    }
    .felx-between{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .bg-color1{
        background: #001498;
    }
    .bg-color2{
        background: #0D2DFF;
    }
    .bg-color3{
        background: #FFBC01;
    }
    .bg-color4{
        background: #36C635;
    }
    .color1{
        color: #17B2FE;
    }
</style>
<style>
    /* .selectCon .el-input{
        width: 300px;
        height: 50px;
    }
    .selectCon .el-input input{
        height: 50px;
        background: #707070;
        color: #ffffff;
        font-size: 18px;
    } */
    .fen-val .el-input__inner{
        background: transparent;
        border: 0;
        font-size: 16px;
        text-align: right;
        color: #fff;
    }
    .fen-sel{
        background: #001498;
        border: 0;
    }
    .fen-sel .el-select-dropdown__empty{
        color: #fff;
    }
    .fen-val.el-select .el-input{
        width: 240px;
    }
    .fen-sel .el-select-dropdown__item.hover,.fen-sel .el-select-dropdown__item:hover{
        background: transparent;
    }
    .fen-sel .el-select-dropdown__item{
        color: #AECFDC;
    }
</style>